import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { resultData } from "../constants";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

function ResultTab() {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();

  return (
    <div>
      <Row className="mb-3">
        <Col lg={12}>
          <div className="d-flex flex-row align-items-baseline justify-content-between">
            <div className="mb-3">
              <span className="fs-5 fw-semibold">Results</span>
            </div>
            <div className="d-flex flex-row align-items-baseline gap-2">
              <div className="search-box">
                <input
                  placeholder="Search.."
                  type="text"
                  className="form-control"
                  style={{ width: "300px", borderColor: "#F7F8FC" }}
                />
                <span className="search-icon mdi mdi-magnify"></span>
              </div>
              <Dropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen(!dropdownOpen)}
                direction="down"
              >
                <DropdownToggle
                  caret
                  style={{
                    backgroundColor: "#3F88E4",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                >
                  + New
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => navigate("/assessment/create")}>
                    New Assessment
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => navigate("/assessment/question-bank")}
                  >
                    New Question
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Button
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #C3D3E2",
                  borderRadius: "8px",
                }}
                className="d-flex flex-row align-items-baseline gap-1"
              >
                <span className="mdi mdi-filter-variant"></span>
                <span>Filter</span>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          {resultData.map((result, index) => {
            return (
              <Card
                style={{
                  backgroundColor: "#F9FCFF",
                  border: "1px solid #7AC7FF",
                  padding: "8px",
                  borderRadius: "8px",
                }}
                key={index}
              >
                <CardBody>
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex flex-row align-items-baseline justify-content-between">
                      <div style={{ fontSize: "18px" }}>{result.title}</div>
                      <div className="mdi mdi-dots-horizontal cursor-pointer"></div>
                    </div>
                    <div
                      className="d-flex flex-row gap-2 align-items-baseline"
                      style={{ color: "#7F7F7F" }}
                    >
                      <div>
                        <span>{result.candidates} Candidate(s) Taking</span>
                      </div>
                      <div>|</div>
                      <div>{result.completed} Completed</div>
                      <div>|</div>
                      <div>Created on {result.expireDate}</div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </Col>
      </Row>
    </div>
  );
}

export default ResultTab;
